var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainNavigation"},[_c('el-steps',{attrs:{"active":_vm.index,"align-center":""}},_vm._l((_vm.getTextArray('motor_nav')),function(item,index){return _c('el-step',{key:item.id,class:{redirectAvailable: _vm.uidSetted},attrs:{"title":_vm.getNav(index)}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21550e14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/wizzard/StepBar.vue
// module id = null
// module chunks = 